import { render, staticRenderFns } from "./qtfy.vue?vue&type=template&id=cc15c3bc&scoped=true&"
import script from "./qtfy.vue?vue&type=script&lang=js&"
export * from "./qtfy.vue?vue&type=script&lang=js&"
import style0 from "./qtfy.vue?vue&type=style&index=0&id=cc15c3bc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc15c3bc",
  null
  
)

export default component.exports